
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/claude-ui",
      function () {
        return require("private-next-pages/claude-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/claude-ui"])
      });
    }
  